import React from 'react';

import {
  ReactionActionType,
  ReactionsType,
} from 'shared_DEPRECATED/components/Reactions/types';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';
import {
  CoachingSessionRecapMessageContent,
  MESSAGE_STATUS,
  MorpheusMessageContent,
  PlainMessageContent,
  UUID,
} from 'features/chat/config/types/Message';
import { ParentMessageNullable } from 'features/chat/config/types/ParentMessage';
import { SendMorpheusMessage } from 'features/chat/config/types/types';
import { isChatMessageSessionRecapType } from 'features/chat/utils/chatMessageUtils';

import { ChatMessageCoachingSessionRecap } from './CoachingSessionRecap';
import { MessageWrapper } from './MessageWrapper';

type StandardMessageProps = {
  id: UUID;
  text: string;
  createdAt: string;
  editedAt?: string;
  status: MESSAGE_STATUS;
  incoming: boolean;
  isMorpheus: boolean;
  markAsRead: (inView: boolean) => void;
  sendReaction: (
    messageId: UUID,
    emoji: string,
    type: ReactionActionType
  ) => void;
  retrySendingMessage: (id: string) => void;
  reactions: ReactionsType;
  attachments?: Attachment[] | UnuploadedAttachment[];
  isTemporary: boolean;
  replyToMessage: ParentMessageNullable;
  fromUserId: string;
  content:
    | PlainMessageContent
    | CoachingSessionRecapMessageContent
    | MorpheusMessageContent;
  sendMorpheusMessage: SendMorpheusMessage;
  shouldMorpheusButtonGlow: boolean;
};

export function StandardMessage(props: StandardMessageProps) {
  const { content, incoming } = props;

  return (
    <MessageWrapper
      {...props}
      content={content as PlainMessageContent}
      renderContent={
        isChatMessageSessionRecapType(content)
          ? () => (
              <ChatMessageCoachingSessionRecap
                {...content}
                isIncoming={incoming}
              />
            )
          : undefined
      }
    />
  );
}
